import { render, staticRenderFns } from "./PaginationDropdown.vue?vue&type=template&id=bbf4bbec&scoped=true"
import script from "./PaginationDropdown.vue?vue&type=script&lang=ts"
export * from "./PaginationDropdown.vue?vue&type=script&lang=ts"
import style0 from "./PaginationDropdown.vue?vue&type=style&index=0&id=bbf4bbec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf4bbec",
  null
  
)

export default component.exports